<template>
  <div id="app" class="nueva">
    <div class="encabezado container">
      <div class="contenido">
        <h4>Ofertas y promociones</h4>
        <h2>Descubre todas <strong>las ofertas</strong></h2>
        <transition name="fade-list">
          <p v-if="loading">Cargando...</p>
        </transition>
      </div>
    </div>
    <div class="listado container">
      <div
        v-if="filteredList.length == 0 && !loading"
        is="transition-group"
        name="fade-list"
        class="no-results"
      >
        <div key="noresults" class="noresults-content">
          <p class="title">¡Hay muchas más oportunidades en tu concesionario!</p>
          <p class="subtitle">Contactate con un asesor y acercate a tu Volkswagen.</p>
          <a
            href="https://www.volkswagen.com.ar/app/formulario/vw-ar/contacteme/es/+/+/+/+/+/+/+/+/+/+/+/+/+/+/+"
            class="btn btn-primary"
          >Consultanos</a>
        </div>
      </div>

      <div v-else>
        <div class="ofertas-wrapper" is="transition-group" name="fade-list">
          <Oferta v-for="oferta in filteredList" :key="oferta.id" :oferta="oferta" class="oferta-item" :ocultar="ocultar"></Oferta>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "./components/Header";
import Oferta from "./components/Oferta";

import axios from "axios";

const API_URL =
  window.location.hostname === "localhost" ? 
    "https://d6-beneficios.vwcontenidos.com.ar/api/beneficios?per_page=100" //test
    : "https://d6-beneficios.vwcontenidos.com.ar/api/beneficios?per_page=100"; //prod

export default {
  name: "app",
  components: {
    // Header,
    Oferta
  },
  data() {
    return {
      loading: true,
      ofertas: [],
      busqueda: "",
      ocultar: true
    };
  },
  mounted: function() {
    document.title = "Volkswagen Argentina | Ofertas";
    this.ocultar = this.getParameterByName('adchan') ? true : false;
    axios.get(API_URL).then(response => {
      this.ofertas = response.data.data;
      this.loading = false;
    });
  },
  methods: {
    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  },
  computed: {
    filteredList() {
      return this.ofertas.filter(oferta => {
        return oferta.modelo
          .toLowerCase()
          .includes(this.busqueda.toLowerCase());
      });
    }
  }
};
</script>

<style lang="scss">
// @import "./assets/scss/_fonts.scss";

// COLORES -----------------
$hover: #f3f5f6;
$blue: #0099da;
$black: #1d1f20;
$white: #ffffff;
// -------------------------

@mixin boxShadow($color: $black) {
  box-shadow: 0px 1px 2px -1px rgba($color, 0.6);
}

* {
  transition: all 300ms ease-in-out;
}

// CORTESÍA ESPAÑA
@font-face {
  font-family: 'vw-head';
  font-weight: 400;
  font-display: swap;
  src: url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwhead-regular.woff2') format('woff2'),
  url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwhead-regular.woff') format('woff');
}

@font-face {
  font-family: 'vw-head';
  font-weight: 700;
  font-display: swap;
  src: url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwhead-bold.woff2') format('woff2'),
  url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwhead-bold.woff') format('woff');
}

@font-face {
  font-family: 'vw-head';
  font-weight: 200;
  font-display: swap;
  src: url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwhead-light.woff2') format('woff2'),
  url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwhead-light.woff') format('woff');
}

@font-face {
  font-family: 'vw-text';
  font-weight: 400;
  font-display: swap;
  src: url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwtext-regular.woff2') format('woff2'),
  url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwtext-regular.woff') format('woff');
}

@font-face {
  font-family: 'vw-text';
  font-weight: 700;
  font-display: swap;
  src: url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwtext-bold.woff2') format('woff2'),
  url('https://www.volkswagen.es:443/idhub/etc/clientlibs/vwa-ngw18/ngw18-frontend/clientlibs/statics/fonts/vwtext-bold.woff') format('woff');
}


#app {
  font-family: "vw-head", Helvetica, Arial, sans-serif;
  font-weight: 400;
  padding-bottom: 3rem;
  color: $black;
  padding-top: 7em;
  .container {
    @media(min-width: 1250px) {
      width: 100%;
    }
    @media(min-width: 1250px) {
      max-width: 1250px;
    }
    @media(min-width: 1556px) {
      max-width: 1556px;
    }
  }

  .contenedor {
    box-sizing: border-box;
    display: grid;
    max-width: 1920px;
    margin: auto;
  }

  .encabezado {
    font-size: 2.2rem;
    margin: 2.2em auto;
    @media (max-width: 677px) {
      font-size: 1.2em;
      padding: 0 2em;
    }

    h4 {
      color: rgb(0, 30, 80);
      font-size: 0.9em;
      margin-bottom: 0;
    }
    h2 {
      font-weight: 300;
      font-size: 2.7em;
      margin-top: 0.05em;
      padding-left: 0.01em;
      letter-spacing: -0.007em;
      margin-bottom: 0.65em;
      @media (max-width: 677px) {
        font-size: 2em;
        margin-top: 7px;
      }
    }
    strong {
      font-weight: bold;
    }
  }

  .listado {
    @media (max-width: 677px) {
      padding: 0;
      & .row {
        margin: 0;
      }
      .oferta {
        padding: 0;
        margin-bottom: 2em;
      }
    }
  }
}

.ofertas-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2em;
  @media all and (min-width: 677px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media all and (min-width: 769px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

// ANIMATION ------------
.fade-list-move {
  transition: all 200ms ease-in;
  transform: scale(1);
  opacity: 1;
}

.fade-list-leave-to {
  transition: all 200ms ease-in-out;
  transform: scale(0.9);
  opacity: 0;
}

// MODAL ------------
.v-dialog-overlay {
  background-color: rgba(#1d1f20, 0.4) !important;
}

.v-dialog {
  font-weight: unset !important;
  color: $black !important;
  font-weight: 400;
}

.v-dialog-header {
  height: 0;
  padding: 0 !important;
}

.v-dialog-container {
  padding: 3rem !important;
  position: relative;
  font-size: 1.1rem;
  max-width: 960px !important;
  font-style: normal;

  strong {
    font-size: 4rem;
    line-height: 1;
  }

  .v-dialog-btn-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    margin: 0 !important;
    font-size: 2rem !important;
  }
}
.v-dialog-footer {
  display: none;
}

// NO RESULTS --------------------
.no-results {
  border: 1px solid #d9d9d9;
  background-color: #f3f5f6;
  padding: 3rem;
  width: 90%;
  max-width: 960px;
  margin: auto;

  .noresults-content {
    text-align: center;
    .title {
      font-size: 3rem;
    }
    .subtitle {
      font-size: 2.4rem;
    }
    a {
      margin-top: 3rem;
      width: 80%;
      max-width: 320px;
    }
  }
}

// RESET BUTTON ------------
.btn-primary {
  font-size: 2rem;
  background-color: $blue;
  border-color: $blue;
  &:hover {
    background-color: darken($color: $blue, $amount: 15);
    border-color: darken($color: $blue, $amount: 15);
  }
}
</style>
